import { useUpdateEffect } from '@cian/react-utils';

import { useCallback, useRef } from 'react';

import { useReduxState } from '@/app/shared/context/ReduxStoreContext';

import { isGeoChanged } from '@/microfrontends/map/shared/utils/isGeoChanged';

import { filtersSelector, useFiltersSelector } from '@/packages/redux-state/store/slices/jsonQuery';

export const useGeoFiltersChanged = (): (() => boolean) => {
  const reduxState = useReduxState();

  const filters = useFiltersSelector();

  const prevFilters = useRef(filters);

  useUpdateEffect(() => {
    if (filters.bbox && prevFilters.current.bbox !== filters.bbox) {
      prevFilters.current = filters;
    }
  }, [filters]);

  return useCallback(() => {
    const nextFilters = filtersSelector(reduxState.getState());

    const geoChanged = isGeoChanged(prevFilters.current, nextFilters);

    if (geoChanged) {
      prevFilters.current = nextFilters;
    }

    return geoChanged;
  }, [reduxState]);
};
